import { createSelector } from 'reselect'
import { RemoteConfigResponse } from 'src/models/remoteConfig.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectRemoteConfigFromState } from 'src/redux/selectors/session.selectors'

export const selectFeatureFlaggerCookiesFromState = (
  state: RootState,
): Partial<RemoteConfigResponse> => state.session.featureFlagger

export const selectFeatureFlaggerFromState = createSelector(
  [
    selectFeatureFlaggerCookiesFromState,
    selectRemoteConfigFromState,
    selectUserListModelFromState,
  ],
  (featureFlagger, remoteConfig, user) => {
    const mergedFeatureFlags = {
      ...remoteConfig,
      ...featureFlagger,
    } satisfies RemoteConfigResponse

    const receiptAgentOrganizationAllowlisted =
      user?.organizationId !== undefined &&
      (mergedFeatureFlags.receipt_agent_organization_allowlist ?? []).includes(
        user.organizationId,
      )
    const receiptAgentOrganizationEnabled =
      mergedFeatureFlags.enable_receipt_agent ||
      receiptAgentOrganizationAllowlisted

    return {
      ...mergedFeatureFlags,
      show_google_workspace_integrations:
        mergedFeatureFlags.show_google_workspace_integrations ||
        receiptAgentOrganizationAllowlisted,
      enable_receipt_agent_transaction_flyout:
        mergedFeatureFlags.enable_receipt_agent_transaction_flyout,
      enable_receipt_agent_transaction_list:
        receiptAgentOrganizationEnabled &&
        mergedFeatureFlags.enable_receipt_agent_transaction_list,
      enable_receipt_recovery_dashboard:
        receiptAgentOrganizationEnabled &&
        mergedFeatureFlags.enable_receipt_recovery_dashboard,
    } satisfies RemoteConfigResponse
  },
)
